<template>
  <div>
    <div class="tc mb-4">
      <h3>{{$route.meta.title}}</h3>
    </div>
    <p class="red-text">注：结算时间仅能设定30分钟以内的时间</p>
    <p class="red-text">注：更改設定，新設定值在23:59:00生效，於下一期生效</p>
    <table class="TB_COLLAPSE" style="width: 100%">
      <thead>
        <tr>
          <th width="30%"></th>
          <th>修改設定</th>
          <th>目前設定</th>
        </tr>
      </thead>
      <tbody v-if="items.before">
        <tr v-for="it in items.before" :key="it.gameid">
          <th>{{GetGameName(it.gameid)}}</th>
          <td>
            <TimePicker
              format="mm分ss秒"
              size="default"
              :clearable="false"
              :disabled-hours="disabledHours"
              :disabled-minutes="disabledMinutes"
              :disabled-seconds="disabledSeconds(itemsAfterTime[it.gameid])"
              :value="itemsAfterTime[it.gameid]"
              :placeholder="placeholder"
              @on-change="$event => changeTime($event, 'itemsAfterTime' ,it.gameid)"
              style="width: 112px"
            ></TimePicker>
          </td>
          <td>
            <TimePicker
              format="mm分ss秒"
              size="default"
              :clearable="false"
              :disabled="true"
              :disabled-hours="disabledHours"
              :disabled-minutes="disabledMinutes"
              :disabled-seconds="disabledSeconds(itemsBeforeTime[it.gameid])"
              :value="itemsBeforeTime[it.gameid]"
              :placeholder="placeholder"
              @on-change="$event => changeTime($event, 'itemsBeforeTime' ,it.gameid)"
              style="width: 112px"
            ></TimePicker>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center my-3">
      <Button
        v-if="modfiyStatus"
        :disabled="buttonState"
        :loading="loading"
        :class="{'setting-disabled': buttonState }"
        type="error"
        size="default"
        @click="Click"
      >儲存</Button>
    </div>
  </div>
</template>
<script>
import { Utile } from 'utils';
import { mapGetters } from 'vuex';
export default {
  name: 'self-lottery-daily-time',
  data () {
    return {
      items: {}, // API接回來資料
      itemsBeforeTime: {}, // 修改設定
      itemsAfterTime: {}, // 目前設定
      itemsAfterTimeDf: {}, // 預設判斷
      placeholder: '请选择分秒',
      // six12: '',
      // sixgc: '',
      // afterSix12: '',
      // afterSixgc: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getpermission', 'getAllGame']),
    disabledHours () { // 回传需disabled掉的小时阵列
      let mathArray = Utile.ArrayRange(23, 0, 1, 0)
      return mathArray.reverse()
    },
    disabledMinutes () { // 回传需disabled掉的分钟阵列
      let mathArray = Utile.ArrayRange(59, 31, 1, 0)
      return mathArray.reverse()
    },
    modfiyStatus () { // 是否可修改
      return this.getpermission.settlement[1] == 1
    },
    buttonState () { // 當新值跟舊值一樣時不能送修改
      const itemsAfterTime = JSON.stringify(this.itemsAfterTime)
      const itemsAfterTimeDf = JSON.stringify(this.itemsAfterTimeDf)
      return itemsAfterTime == itemsAfterTimeDf
    },
  },
  created () {
    this.GetLotteryDailyTime()
  },
  methods: {
    async GetLotteryDailyTime () { // 取得 日開彩結算時間
      try {
        const res = await this.$axios.gameLobby.GetLotteryDailyTime()
        if ('status' in res && res.status === 0) return
        this.items = res
        this.itemsBeforeTime = res.before.reduce((acc, val) => {
          acc[val.gameid] = this.CombinationTime(val)
          return acc
        }, {})
        this.itemsAfterTime = res.After.reduce((acc, val) => {
          acc[val.gameid] = this.CombinationTime(val)
          return acc
        }, {})
        this.itemsAfterTimeDf = { ...this.itemsAfterTime }
      } catch (error) {
        console.log(error);
      }
    },
    async SettingLotteryDailyTime (data) { // 修改 日開彩結算時間设定
      this.loading = true
      try {
        const res = await this.$axios.gameLobby.SettingLotteryDailyTime(data)
        if (res.status == 1) {
          this.$Message.success("设定成功");
        }
        setTimeout(() => this.loading = false, 2000)
      } catch (error) {
        console.log(error);
        this.loading = false
      }
    },
    postData (id, item) { // 组合 post 需要的参数
      const result = {}
      result['gameid'] = id
      result['minute'] = Number(item.split(':')[0])
      result['secend'] = Number(item.split(':')[1])
      return result
    },
    async Click () { // 点击储存判断
      if (this.buttonState) return
      for (const it in this.itemsAfterTime) {
        if (this.itemsAfterTime[it] == this.itemsAfterTimeDf[it]) continue;
        const postData = this.postData(it, this.itemsAfterTime[it])
        await this.SettingLotteryDailyTime(postData)
      }
      await this.GetLotteryDailyTime()
    },
    disabledSeconds (data) { // 秒数选单在选择 30分时，将秒数给隐藏掉
      if (!data || data.split(':')[0] < 30) return []
      let mathArray = Utile.ArrayRange(59, 1, 1, 0)
      return mathArray.reverse()
    },
    CombinationTime (item) { // 取得 分:秒 格式时间
      if (!item) return
      const minute = item.minute < 10 ? `0${item.minute}` : item.minute
      const secend = item.secend < 10 ? `0${item.secend}` : item.secend
      return `${minute}:${secend}`
    },
    GetGameName (id) {
      if (!id) return
      const result = this.getAllGame.find(it => it.gameid == id)
      return result.gamename || ''
    },
    changeTime (event, item, key) {
      let data = event.replace(/分/g, ":").replace(/秒/g, "");
      this[item][key] = data
    }
  }
}
</script>
<style lang="scss">
.button-dei {
  background: #ed4014;
}
</style>